module.exports = __webpack_public_path__ + "static/tulips-zoom-492f5d888b84d4769f353711b441b83a.jpg";